import { ErrorWrapper, ResponseWrapper } from '@/services/util';

export default {
  async getList(relatedId, parameters = {}) {
    const params = { ...parameters };

    try {
      const response = await this.request({
        auth: true
      }).get(`${this.entity(relatedId)}`, {
        params
      });

      return new ResponseWrapper(response, response.data);
    } catch (error) {
      const message = error.response.data
        ? error.response.data.error
        : error.response.statusText;
      throw new ErrorWrapper(error, message);
    }
  },

  getById: async function(relatedId, id) {
    try {
      const response = await this.request({ auth: true }).get(
        `${this.entity(relatedId)}/${id}`
      );
      return new ResponseWrapper(response, response.data.data);
    } catch (error) {
      const message = error.response.data
        ? error.response.data.error
        : error.response.statusText;
      throw new ErrorWrapper(error, message);
    }
  },

  create: async function(relatedId, data = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        `${this.entity(relatedId)}`,
        data
      );
      return new ResponseWrapper(response, response.data.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  },

  update: async function(relatedId, data = {}) {
    try {
      const response = await this.request({ auth: true }).patch(
        `${this.entity(relatedId)}/${data.related_id}`,
        data
      );
      return new ResponseWrapper(response, response.data.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  },

  remove: async function(relatedId, id) {
    try {
      const response = await this.request({ auth: true }).delete(
        `${this.entity(relatedId)}/${id}`
      );
      return new ResponseWrapper(response, response.data.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }
};
